import { ReactElement } from 'react'
import {
  STEP_COMPONENTS,
  StepKey
} from 'src/componentsV2/CoreUX/OnboardingSteps/steps'

interface OnboardingStep {
  name: string
  enabled: boolean
  completed: boolean
}

export function useOnboardingSteps() {
  const getStepComponent = (step: OnboardingStep): ReactElement | null => {
    const StepComponent = STEP_COMPONENTS[step.name as StepKey]

    if (!StepComponent) {
      console.warn(`No component found for step: ${step.name}`)
      return null
    }

    return <StepComponent completed={step.completed} enabled={step.enabled} />
  }

  return { getStepComponent }
}
